import {getStories} from '../utils/api'
import {Story} from '../components/story'

tag home-page
	prop type = "news"
	prop page = 1
	def routed params, state
		page = params.page ?? 1
		data = state.type ||= await getStories type, page
		window.scrollTo(0, 0)
	<self>
		<div.news-view>
			<div.news-list-nav>
				if page > 1
					<a.page-link route-to=`/{type}/{Number(page) - 1}` aria-label="Previous Page"> "< prev"
				else
					<span.page-link.disabled aria-hidden="true"> "< prev"
				<span> "page {route.params.page ?? 1}"
				if data.length >= 28
					<a.page-link route-to=`/{type}/{Number(page) + 1}` aria-label="Next Page"> "more >"
				else
					<span.page-link.disabled aria-hidden="true"> "more >"
			<main.news-list>
				<ul>
					for story in data
						<li.news-item>
							<Story story=story>